import * as firebase from 'firebase/app';
import 'firebase/analytics';
import { cookieAllowed, CookieTypes } from '../utils/cookieUtils';
import AbstractAnalyticsService from './AbstractAnalyticsService';
import { firebaseConfig } from '../options';

/* eslint-disable no-empty-function */
/** @type {AbstractAnalyticsService} */
class AnalyticsServiceWeb extends AbstractAnalyticsService {}

const analyticsMock = {
    setUserId: () => null,
    logEvent: () => null
};

let firebaseInitalized = false;
if (cookieAllowed(CookieTypes.googleAnalytics)) {
    firebase.initializeApp(firebaseConfig);
    firebaseInitalized = true;
}
// TODO: FIX ME
const analyticsModule = /*firebaseInitalized ? firebase.analytics() :*/ analyticsMock;
export default new AnalyticsServiceWeb(analyticsModule);
